module.exports = __webpack_public_path__ + "media/images/athletes/3547-8a5dfb1239fcd2c0a95f1c39fe3bc8c2.png";